import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import { CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { CustomCardModule } from 'src/app/spartacus/custom/shared/components/custom-card/custom-card.module';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomUserAddressesEffects } from '../../../../core/user/store/effects/user-addresses-zone.effect';
import {
  reducerAddressesByZoneProvider,
  reducerAddressesByZoneToken
} from '../../../../core/user/store/reducers/user-addresses-zone.reducer';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomAddressFormModule } from './address-form/custom-address-form.module';
import { CustomShippingAddressComponent } from './custom-shipping-address.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CustomAddressFormModule,
    CustomCardModule,
    SpinnerModule,
    I18nModule,
    CustomIconsModule,
    StoreModule.forFeature('user-address-zone', reducerAddressesByZoneToken),
    EffectsModule.forFeature([CustomUserAddressesEffects]),
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutShippingAddress: {
          component: CustomShippingAddressComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomShippingAddressComponent],
  exports: [CustomShippingAddressComponent],
  providers: [reducerAddressesByZoneProvider]
})
export class CustomShippingAddressModule {
}
